module.exports = __webpack_public_path__ + "img/Elaine Beech.c76dfe82.jpg";